import React from 'react';
import styles from './globalStyles.scss';

// Workaround due to incorrect styles imports order in production build
// https://github.com/vercel/next.js/issues/16630
const GlobalStyles = ({ children }: { children: React.ReactNode | React.ReactNode[] }) => <>{ children }</>;

export default GlobalStyles;
export { styles };
